/** @format */
import { FilterTextField } from 'components';

const columns = (SeeDetailBtn , currencyText) => [
  {
    title: 'شناسه سرویس',
    field: 'serviceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'نام سرویس',
    field: 'serviceName',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'نام فارسی سرویس',
    field: 'PersianServiceName',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'شناسه کسب و کار فروشنده',
    field: 'salerId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'نام کسب و کار فروشنده',
    field: 'salerName',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'مجموع تعداد فراخوانی موفق',
    field: 'numberOfSuccessCalls',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'مجموع تعداد فراخوانی ناموفق',
    field: 'numberOfFailedCalls',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'مجموع تعداد فراخوانی',
    field: 'numberOfCalls',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: `مجموع مبلغ فروش (${currencyText})`,
    field: 'totalSales',
    align: 'center',
    filterComponent: (props) => <FilterTextField numeric size="small" {...props} />,
  },

  {
    title: 'عملیات',
    field: 'details',
    filtering: false,
    align: 'center',
    sorting: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => <SeeDetailBtn id={rowData.serviceId} />,
  },
];

const columnsId = {
  serviceId: '2276',
  serviceName: '2277',
  PersianServiceName: '2278',
  salerId: '2279',
  salerName: '2280',
  numberOfSuccessCalls: ['2281', '2282'],
  numberOfFailedCalls: ['2283', '2284'],
  numberOfCalls: ['2285', '2286'],
  totalSales: ['2287', '2288'],
};

export { columns, columnsId };
